export * from '@leafer-ui/interface'

export * from '@leafer/worker-core'
export * from '@leafer-draw/partner'

export * from '@leafer-ui/draw'
export * from '@leafer-ui/partner'

import { useCanvas } from '@leafer/worker-core'

useCanvas('canvas')